<template>
  <Word
    v-bind="bindProps"
    :bgImg="require('@/assets/word_bowl.png')"
    :bgMask="require('@/assets/word_bowl_mask.svg')"
    v-on="$listeners"
    :class="$style.word"
  >
    {{ word.word }}
    <template v-slot:after v-if="hasAudio">
      <SpeakerIcon @click.stop="audioPlay()" :z="10" />
    </template>
  </Word>
</template>

<script>
import wordMixin from '@/mixins/word'
import audioMixin from '@/mixins/audio'

export default {
  mixins: [wordMixin(), audioMixin()],
  async created () {
    await this.init()
  },
  methods: {
    async init () {
      try {
        await this.initAudio()
      } catch (e) {
        //
      }
    },
    async initAudio () {
      const audio = this.word.audio
      try {
        await this.parseAudio(audio).map(async (file) => {
          const src = require(`!file-loader!@/assets/audio/sound-symbol/${file.src}`)
          return await this.audioLoad({ src })
        })
      } catch (e) {
        //
      }
    },
  },
}
</script>

<style lang="scss" module>
$width: 14rem;

.word {
  width: $width;
  height: $width * 0.55;
  @apply mx-4;
  @apply my-4;
}
</style>
